<div class="card">
    <div class="p-grid">
        <div class="p-col-12 p-lg-2 p-md-2">
            <p-button styleClass="fullwidthbtn" label="Back" routerLink="/deal/{{dealId}}"></p-button>
        </div>
        <div class="p-col-12 p-lg-4 p-md-4">
            <p-button styleClass="fullwidthbtn" label="Add Additional Communication" (click)="showSearchBrokerDialog()"></p-button>
        </div>
        <div class="p-col-12">
            <p-table [value]="users" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th><b>Name</b></th>
                        <th><b>Email</b></th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-user>
                    <tr>
                        <td style="word-wrap: break-word;">{{user.FName}} {{user.LName}}</td>
                        <td style="word-wrap: break-word;">{{user.Email}}</td>
                        <td style="text-align: right">
                            <div *ngIf="canDeleteDealCommunicationUser"><button pButton type="button" class="p-button-primary" label="Remove" (click)="deleteUser(user)"></button></div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<p-dialog [breakpoints]="{'960px': '100vw'}" styleClass="dialog-medium" draggable="false" modal="true" [closable]="false" header="Add Additional Communication" [(visible)]="searchUserDialogVisible">
    <p-divider></p-divider>
    <div class="p-grid">
        <div class="p-col-12 error-notify-text" *ngIf="searchUserDialogMessage.length>0">
            {{searchUserDialogMessage}}
        </div>
        <div class="p-col-10">
            <input type="text"
                   pInputText
                   [(ngModel)]="searchUserText"
                   name="searchUserText"
                   (keyup.enter)="searchUser()" />
        </div>
        <div class="p-col-2">
            <button pButton type="button" icon="pi pi-search" iconPos="left" (click)="searchUser()"></button>
        </div>
        <div class="p-col-12" *ngIf="searchUserResultList.length>0">
            <p-dataView #dv [value]="searchUserResultList"
                        [paginator]="true"
                        filterBy="FName,LName"
                        [rows]="5"
                        [showCurrentPageReport]="true"
                        [rowsPerPageOptions]="rowsPerPageOptions"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                <ng-template let-user pTemplate="listItem">
                    <div class="p-col-12">
                        <div class="object-list-item">
                            <img class="profilePicture" [src]="'data:image/png;base64,' + user.ProfilePicture" style="height: 75px; width: 75px;" />
                            <div class="object-list-detail">
                                <div class=""><b>{{user.FName}} {{user.LName}}</b></div>
                                <div class=""><b>{{user.DefaultMemberName}}</b></div>
                                <div class=""><b>Email: </b>{{user.Email}}</div>
                                <div class=""><b>Phone: </b>{{user.DirectPhone}}</div>
                            </div>
                            <div class="object-list-action">
                                <p-button label="Add User" (click)="addUser(user)"></p-button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-dataView>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="Cancel" (click)="hideSearchUserDialog()"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog header="Confirmation" icon="ui-icon-warning" width="800"></p-confirmDialog>
